var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 14.667C20.6509 14.667 14.6665 20.6514 14.6665 28.0003C14.6665 35.3493 20.6509 41.3337 27.9998 41.3337C35.3488 41.3337 41.3332 35.3493 41.3332 28.0003C41.3332 24.6826 40.0936 21.667 38.0832 19.3337L41.4165 16.0003H33.3332V24.0837L36.2082 21.2087C37.7394 23.0472 38.6665 25.4066 38.6665 28.0003C38.6665 33.9066 33.9061 38.667 27.9998 38.667C22.0936 38.667 17.3332 33.9066 17.3332 28.0003C17.3332 22.0941 22.0936 17.3337 27.9998 17.3337V14.667ZM27.9998 20.0003C25.7915 20.0003 23.9998 21.792 23.9998 24.0003C23.9998 26.2087 25.7915 28.0003 27.9998 28.0003C30.2082 28.0003 31.9998 26.2087 31.9998 24.0003C31.9998 21.792 30.2082 20.0003 27.9998 20.0003ZM27.9998 30.667C24.505 30.667 22.38 32.1253 21.2082 33.3753C22.7967 35.3701 25.255 36.667 27.9998 36.667C30.7446 36.667 33.203 35.3701 34.7915 33.3753C33.6196 32.1253 31.4946 30.667 27.9998 30.667Z",
    fill: "#12171F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E0E5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.f5268c7ebe75354a46e220fd86a2d69c.svg";
export { ForwardRef as ReactComponent };